import React, { useState } from "react";

const descriptions = {
  ru: [
    'В Pokerly баги не чиним — только оцениваем. Создайте комнату, соберите тиммейтов и раздайте story points, как карты.',
    'В Pokerly задачи из Джиры получают story points быстрее, чем вы успеете сказать «ещё один grooming?»',
    'Даже продакт поймёт, почему в Pokerly эта «мелочь на пару часов» тянет на 13 story points.',
    'В Pokerly каждый раунд — это битва взглядов: backend говорит «5», frontend — «13», а дизайнер просто смотрит с вопросом в глазах.',
    'Pokerly — это не покер, но карточки, фишки и лёгкий азарт в комплекте. Создайте комнату и пусть оценки говорят сами за себя.',
    'В Pokerly всё начинается с “давайте быстро оценим” — и заканчивается ретроспективой на два часа. Классика.',
    'В Pokerly можно за один созвон оценить десятки задач — без ссор, боли и фраз “давайте обсудим это позже”. Просто фасилитатор, короткий питч и бакет-система, которая всё разложит по полочкам.',
    'Тут вы не выбираете между «5» и «8». Вы просто оцениваете задачи партиями — по 5 штук за раз. Быстро, по делу, с фасилитатором, который не даст увязнуть в обсуждениях.',
    'Pokerly — когда бэклог огромный, а времени — как перед демо. Делим всё на итерации, слушаем продакта, кидаем оценки и летим дальше. Даже Jira удивится, как вы это сделали.',
    'Никаких “а давайте подискутируем”… В бакет-сессиях Pokerly задачи проходят строем: короткий бриф — и вперёд, на голосование. В конце видно, где всё понятно, а где надо звать на ПБР.',
    'Это не просто планирование. Это планирование с режимом турбо. Бакет-система в Pokerly — для тех, кто хочет навести порядок в хаосе задач и не утонуть в «ещё одной мелочи».',
    'С Pokerly оценка задач превращается в чёткий процесс: без флуда, без крика, без “да это на пару часов”. Просто коротко, точно и в темпе. Особенно с бакетами — они знают своё дело.',
  ],
  en: [
    'At Pokerly, we don’t fix bugs — we just estimate them. Create a room, gather your team, and deal out story points like cards.',
    'In Pokerly, Jira tasks get story points faster than you can say “just one more grooming?”',
    'Even your product manager will get why that “quick fix” turned into a 13-pointer in Pokerly.',
    'Every round in Pokerly is a standoff: backend says "5", frontend says "13", and the designer just silently panics.',
    'Pokerly isn’t poker, but it’s got cards, vibes, and a bit of drama. Create a room and let the story points do the talking.',
    'Every Pokerly session starts with “let’s estimate real quick” and ends two hours later with a retro. Classic.',
    'With Pokerly’s bucket mode, you can estimate dozens of tasks in a single session — no chaos, no arguments, no “let’s park this”. Just structure, speed, and clarity.',
    'No need to pick between “5” and “8”. In Pokerly buckets, you estimate tasks in batches — 5 at a time. Fast, focused, and facilitation-friendly.',
    'Pokerly is made for those huge backlogs and tight deadlines. One short pitch, quick votes, move to the next batch. Even Jira won’t believe it.',
    'No endless debates here. In bucket mode, tasks march through in formation: quick briefing, fast voting, and results that actually mean something.',
    'This isn’t just planning — this is planning on turbo mode. Pokerly’s bucket system keeps things clear, clean, and moving.',
    'Estimation with Pokerly is sharp, clean, and calm. No rambling, no drama, no “it’s just a couple of hours”. Just solid decisions — especially with buckets.',
  ],
};

interface DynamicDescriptionProps {
  lang: "ru" | "en";
}

const DynamicDescription: React.FC<DynamicDescriptionProps> = ({ lang }) => {
  const list = descriptions[lang];
  const [randomIndex] = useState(() =>
    Math.floor(Math.random() * list.length)
  );

  return <p>{list[randomIndex]}</p>;
};

export default DynamicDescription;
